import { render, staticRenderFns } from "./BdKnowledge.vue?vue&type=template&id=52614e7b&"
import script from "./BdKnowledge.vue?vue&type=script&lang=js&"
export * from "./BdKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports